var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tool",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.391,
    height: 20,
    viewBox: "0 0 14.391 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M31.664,961.525a1.749,1.749,0,0,0-1.795.229,4.813,4.813,0,0,0-1.538,1.636,3.526,3.526,0,0,0-.053,3.486l-4.756,8.2a3.152,3.152,0,1,0,2.888,4.721,3.132,3.132,0,0,0,.066-3.024l4.756-8.2a3.563,3.563,0,0,0,3.008-1.789,4.771,4.771,0,0,0,.648-2.147,1.729,1.729,0,0,0-.692-1.657.254.254,0,0,0-.333.089l-1.591,2.726-2.11-1.212,1.591-2.726A.251.251,0,0,0,31.664,961.525ZM24.2,977.28c.233.326.45.663.67,1-.172.315-.354.625-.534.935-.4-.025-.8-.046-1.2-.068-.227-.331-.446-.668-.666-1,.17-.313.351-.62.53-.929C23.4,977.226,23.8,977.255,24.2,977.28Z",
    transform: "translate(-20.5 -961.362)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceType);
export default __webpack_public_path__ + "static/media/serviceType.97fc666e.svg";
export { ForwardRef as ReactComponent };